<template>
  <fin-dialog fullscreen
              :value="value"
              @input="closeDialog">
    <template #title>
      Suche
      <fin-search :resolver="searchAssets"
                  style="margin-top: 20px"
                  @searchResult="val => searchResult=val"
                  ref="finSearch"/>
    </template>
    <template>
            <v-list style="margin-top: -18px">
              <v-list-item v-for="(result, index) in searchResult" :key="index" class="px-0">
                <v-list-item-content @click="searchResultClicked(result)">
                  <v-row class="mx-0">
                    <v-col cols="auto" class="px-0">
                      <fin-circle :fill="getCircleColor(result.instrument.assetClass)" :size="8" class="mx-2"/>
                    </v-col>
                    <v-col class="px-0">
                      {{ result.instrument.name }}
                      <br>
                      ({{ result.instrument.isin }})
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <template v-if="searchResult.length > 0">
                <div v-intersect="{
            handler: onIntersect,
          }"/>
              </template>
            </v-list>
    </template>
  </fin-dialog>
</template>

<script>
import {
  DEFAULT_SHARE_ETF_ITEM, searchAllByNameOrISIN,
} from "@/components/common/AssetsNameIsinAutocomplete/graphql"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import FinSearch from "@/components/common/Search"
import FinCircle from "@/components/common/shapes/Circle"
import AssetClassFinder from "@/components/pages/onboarding/AssetClassFinder"

export default {
  name: "FinMobileSearch",
  components: {FinCircle, FinSearch},
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      searchResult: []
    }
  },
  methods: {
    getCircleColor(assetClass) {
      return AssetClassFinder.findById(assetClass)?.color
    },
    closeDialog() {
      this.$emit('input', false)
    },
    searchResultClicked({instrument}) {
      if (instrument.assetClass === 'SHARE' && (this.$route.name === 'companyDetail' && this.$route.params.id !== instrument.id || this.$route.name !== 'companyDetail')) {
        this.$router.push({name: 'companyDetail', params: {id: instrument.id}})
        this.closeDialog()
      } else if (instrument.assetClass !== 'SHARE' && (this.$route.name === 'etfDetail' && this.$route.params.id !== instrument.id || this.$route.name !== 'etfDetail')) {
        this.$router.push({name: 'etfDetail', params: {id: instrument.id}})
        this.closeDialog()
      }
    },
    async searchAssets({searchKeyword, from}) {
      const returnItem = this.customReturnItem ? this.customReturnItem : DEFAULT_SHARE_ETF_ITEM

      let searchQuery = searchAllByNameOrISIN
      let resultObjName = 'searchInstruments'

      searchQuery = searchQuery.replaceAll('$returnItem', returnItem)
      searchQuery = searchQuery.replace('$optionalAndFilters', '')

      let result = await API.graphql(graphqlOperation(searchQuery, {
        limit: 20,
        from,
        searchKeyword: searchKeyword
      }))
      return result.data[resultObjName].items
    },
    onIntersect(entries, observer) {
      if (entries[0].intersectionRatio >= 0.5 && !this.emptyOrLastResult) {
        this.$refs.finSearch._loading()
      }
    },
  },
  watch: {
    value(val) {
      if(val) {
        setTimeout(() => this.$refs.finSearch.focus(), 100)
      }
    }
  }
}
</script>

<style scoped>

</style>
